<template>
  <img :src="src" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { AttachmentInput, Attachment } from '@/gql/myomr'

const props = defineProps<{
  image: Attachment | AttachmentInput
}>()

const src = computed(() => {
  if ('url' in props.image) {
    return props.image.url
  } else {
    return URL.createObjectURL(props.image.file as File)
  }
})
</script>
